import { Breadcrumb, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams, useNavigate } from "react-router-dom";

import { Loading } from "components";
import IconArrowBack from "components/Icons/IconArrowBack/IconArrowBack";
import { AssignmentDetailPractice } from "features";
import { TutoringHistoryAssignmentDetailHeader } from "components/AssignmentDetailHeader/TutoringAssignmentDetailHeader";

import { useUserAssignmentDetail } from "utils/hooks/useUserAssignmentDetail";

const TutoringDetailPage = () => {
  const { t } = useTranslation(["history"]);
  const { tutoringId, userAssignmentId } = useParams();

  const navigate = useNavigate();

  const { assignmentData, isLoading, isUnavailable, title } = useUserAssignmentDetail(userAssignmentId);

  // AIDEV-NOTE: Kontrola parametrů musí být pod všemi hooky, jinak se při změně parametrů změní jejich počet. [TD-487]
  if (!tutoringId || !userAssignmentId) return null;

  const navigateAssignment = (newAssignmentId: string) => {
    navigate(`/historie/doucovani/${tutoringId}/${newAssignmentId}`);
  };
  return (
    <>
      <div className={"page-header page-header--has-tabs"}>
        <Container className={"container-mw-md"}>
          <Breadcrumb>
            <li className={"breadcrumb-item"}>
              <Link to="/historie">
                <IconArrowBack />
                {t("back", { ns: "common" })}
              </Link>
            </li>
          </Breadcrumb>

          <TutoringHistoryAssignmentDetailHeader
            assignmentId={assignmentData?.assignment?.id ?? ""}
            userAssignmentId={userAssignmentId}
            tutoringId={tutoringId}
            onNavigate={navigateAssignment}
            title={title}
          />
        </Container>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <AssignmentDetailPractice
          assignment={assignmentData}
          userAssignmentId={userAssignmentId}
          isUnavailable={isUnavailable}
        />
      )}
    </>
  );
};

export default TutoringDetailPage;
